import io from 'socket.io-client'
import documentVisibility from 'helpers/documentVisibility'

const status = {
	IDLE: 'idle',
	CONNECTING: 'connecting',
	CONNECTED: 'connected',
	DESTROYED: 'destroyed',
	DISCONNECTED: 'disconnected',
	FAILED: 'failed',
}

class Socket extends Object {
	constructor(endpoint, transports) {
		super()
		this.endpoint = endpoint
		this.transports = transports
		this._status = status.IDLE
		this._query = {}
	}

	connect = async query => {
		if (documentVisibility.isHidden()) {
			await documentVisibility.waitForReconnection()
		}
		if ([
			status.CONNECTING,
			status.CONNECTED,
			status.DISCONNECTED,
		].includes(this._status)) {
			this._query = query || this._query
			this.socket.query = this._query
			this.socket.io.opts.query = this._query
			this.socket.connect()
		} else {
			this._query = query || this._query
			this._status = status.CONNECTING
			this.socket = io(this.endpoint, {
				transports: this.transports,
				query: this._query,
			})
		}
		return new Promise((resolve, reject) => {
			this.socket.on('connect', () => {
				this._status = status.CONNECTED
				resolve(this)
			})
			this.socket.on('error', () => {
				this._status = status.FAILED
				reject(this)
			})
			this.socket.on('connect_error', () => {
				this._status = status.FAILED
				reject(this)
			})
		})
	}

	disconnect = () => new Promise(resolve => {
		this.socket.disconnect()
		this._status = status.DISCONNECTED
		resolve(this)
	})

	destroy = () => new Promise(resolve => {
		this.socket.disconnect()
		this._status = status.DESTROYED
		resolve(this)
	})

	on = (event, handler) => {
		this.socket.on(event, handler)
	}

	off = (event, handler) => {
		this.socket.removeListener(event, handler)
	}

	emit = (event, data) => new Promise(resolve => {
		this.socket.emit(event, data, response => {
			resolve(response)
		})
	})

	getStatus = () => this._status
}

const sockets = []

function connect(endpoint, transports = ['polling', 'websocket']) {
	let socketCacheData = sockets.find(socketCache => socketCache.endpoint === endpoint)
	if (!socketCacheData) {
		socketCacheData = {
			endpoint,
			socket: new Socket(endpoint, transports),
		}
		sockets.push(socketCacheData)
	} else if ([
		status.FAILED,
		status.DESTROYED,
	].includes(socketCacheData.socket.getStatus())) {
		socketCacheData.socket = new Socket(endpoint, transports)
	}
	return socketCacheData.socket
}

(function() {
	const disconnectSockets = () => {
		sockets.forEach(socketCache => {
			if ([
				status.CONNECTING,
				status.CONNECTED,
			].includes(socketCache.socket.getStatus())) {
				socketCache.socket.disconnect()
			}
		})
	}

	let disconnectTimeout
	const handleVisibilityChange = () => {
		if (documentVisibility.isHidden()) {
			disconnectTimeout = setTimeout(disconnectSockets, 60000)
		} else {
			clearTimeout(disconnectTimeout)
		}
	}

	if (documentVisibility.isSupported()) {
		documentVisibility.onChange(handleVisibilityChange)
	}
}())

export default connect
